import { useEffect, useRef } from "react";
import * as PIXI from "pixi.js";

import brushStroke from "../../assets/brush_stroke_01.png";

const WIDTH = 2390;
const HEIGHT = 1000;

function lerpColor(colorA, colorB, t) {
    const ar = (colorA >> 16) & 255;
    const ag = (colorA >> 8) & 255;
    const ab = colorA & 255;

    const br = (colorB >> 16) & 255;
    const bg = (colorB >> 8) & 255;
    const bb = colorB & 255;

    const r = Math.round(ar + (br - ar) * t);
    const g = Math.round(ag + (bg - ag) * t);
    const b = Math.round(ab + (bb - ab) * t);

    return (r << 16) + (g << 8) + b;
}

export default function PixiBrushBackground() {
    const containerRef = useRef(null);

    useEffect(() => {
        let app;
        let destroyed = false;

        async function initPixi() {
            app = new PIXI.Application();

            await app.init({
                width: WIDTH,
                height: HEIGHT,
                backgroundAlpha: 0,
                antialias:  true
            });

            if (destroyed || !containerRef.current) {
                app.destroy(true);
                return;
            }

            containerRef.current.appendChild(app.canvas);

            const texture = await PIXI.Assets.load(brushStroke);

            const topColor = 0xfffaf5;
            const bottomColor = 0xffe8d1;

            // const baseWidth = 420;
            // const baseHeight = 420;
            const baseWidth = texture.width;
            const baseHeight = texture.height;

            for (let y = -baseHeight; y < HEIGHT + baseHeight; y += 90) {
                for (let x = -baseWidth; x < WIDTH + baseWidth; x += 260) {
                    const sprite = new PIXI.Sprite(texture);

                    const jitterX = Math.random() * 120 - 60;
                    const jitterY = Math.random() * 60 - 30;

                    const scale = 0.6 + Math.random() * 0.2;

                    sprite.scale.set(scale)

                    sprite.x = x + jitterX;
                    sprite.y = y + jitterY;

                    sprite.rotation = (Math.random() * 0.4) - 0.2;
                    sprite.alpha = 0.45 + Math.random() * 0.25;

                    const verticalPercent = Math.min(Math.max(sprite.y / HEIGHT, 0), 1);
                    sprite.tint = lerpColor(topColor, bottomColor, verticalPercent);

                    app.stage.addChild(sprite);
                }
            }

        }

        initPixi();

        return () => {
            destroyed = true;

            if (app) {
                app.destroy(true);
            }
        };
    }, []);

    return <div className="pixi-brush-background" ref={containerRef}></div>
}